import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import styles from './EngageSidebar.module.scss';
import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';

export default function SidebarLogo(props) {
  const { mini, link, allowAnimation, src = null } = props;

  const { t } = useTranslation();

  return (
    <>
      {src ? (
        <div className={styles.sidebarLogo}>
          <img src={src} className={styles.iconLogo} alt={t('logo_chooser.header')} />
        </div>
      ) : (
        <>
          {link ? (
            <Link
              className={cx(styles.sidebarLogo, { [styles.mini]: mini, [styles.animate]: allowAnimation })}
              to={link ? '/eg/home' : '#'}
              aria-label='Home'
            >
              <Icon className={mini ? styles.iconLogoMini : styles.iconLogo} src={mini ? 'logoMini' : 'logo'} />
            </Link>
          ) : (
            <div className={cx(styles.sidebarLogo, { [styles.mini]: mini, [styles.animate]: allowAnimation })}>
              <Icon className={mini ? styles.iconLogoMini : styles.iconLogo} src={mini ? 'logoMini' : 'logo'} />
            </div>
          )}
        </>
      )}
    </>
  );
}
